/**
 * Login/ResetPassword Controller
 *
 * 
 */

// the constructor for this object
function LoginResetPasswordController() { }

// the object
LoginResetPasswordController.prototype = {
    constructor: LoginResetPasswordController,
    
    // the reset key of the user, passed from the URI
    resetKey: null,
    
    // the email of the user, passed from the URI
    email: null,
    
    // initialize the controller
    init: function() 
    {
        // register the route variables used by this controller
        this._registerRouteVariables();
        
        PortalHelper.debugMessage('Reset Password Controller Initialized');
    },
    
    // run the controller
    run: function()
    {
        // register the events used by this controller
        this._registerEvents();
        
        // set the default form data that was passed from the URI
        this._setDefaultFormData();
        
        // turn on the submit button
        PortalHelper.enableButton('#reset-password-button');
        
        PortalHelper.debugMessage('Reset Password Controller Ran');
    },
    
    // get the route variables and include them in the controller
    _registerRouteVariables: function() 
    {
        var segments = PortalMain.getRouteSegments();
        
        // set the product cd
        if (segments.length == 2) {
            this.resetKey = segments[0];
            this.email = decodeURIComponent(segments[1]);
        } else {
            // the uri is missing important pieces
            PortalHelper.sendToDashboard();
        }
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {   
        // handle the reset password submit event
        $('#reset-password-form').on('submit', function(e) {
            e.preventDefault();
            
            if($('#reset-password-form').parsley().validate()) {
                
                var resetKey = $('#reset-password-form #reset-key').val();
                var email = $('#reset-password-form #email').val();
                var password = $('#reset-password-form #password').val();
                var passwordConfirm = $('#reset-password-form #password-confirm').val();
                
                // disable reset password button while making request
                $(this).off('submit');
                PortalMain.LoginResetPasswordController._resetPassword(
                    resetKey,
                    email,
                    password,
                    passwordConfirm
                );
            }
        });
    },
    
    // fill the form with the default data passed from the URI
    _setDefaultFormData: function()
    {
        $('#reset-password-form #reset-key').val(this.resetKey);
        $('#reset-password-form #email').val(this.email);
    },
    
    // get the tickets and data and populate the list
    _resetPassword: function(resetKey, email, password, passwordConfirm) 
    {    
        PortalHelper.loadingOverlay('#reset-password-form', true);
        var resetRequest = new PortalRequest;
        resetRequest.errorElement = '#reset-password-form .form-errors';
        resetRequest.makeRequest(
            '/auth/reset-password',
            {
                reset_key: resetKey,
                email_nm: email,
                passwd: password,
                confirm: passwordConfirm
            },
            function(data, code, message) {
                $('#reset-password-form .form-success').removeClass('hidden');
                PortalMain.LoginResetPasswordController._redirectToLogin();
            },
            function() {
                // re-enable reset-password button
                PortalMain.LoginResetPasswordController._registerEvents();
            }
        );
        PortalHelper.loadingOverlay('#reset-password-form', false);
    },
    
    // return the user to the login page
    _redirectToLogin: function()
    {
        setTimeout(function () {
            window.location.href = PortalConfig.portalUrl + '/login/';
        }, 3000);  
    },
    
}